import { render } from "./AmendItinerary.vue?vue&type=template&id=dcc4fc86&scoped=true&lang=pug"
import script from "./AmendItinerary.vue?vue&type=script&lang=ts"
export * from "./AmendItinerary.vue?vue&type=script&lang=ts"

import "./AmendItinerary.vue?vue&type=style&index=0&id=dcc4fc86&lang=scss"
import "./AmendItinerary.vue?vue&type=style&index=1&id=dcc4fc86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dcc4fc86"

export default script